import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { Paths } from "../../../paths";

export const ownershipFormsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

	getOwnershipFormsList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.ownershipforms }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getOwnershipFormsById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.ownershipforms }/${ id }`,
		method: 'GET'
	  })
	}),
	addOwnershipForms: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.ownershipforms }`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editOwnershipForms: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body,) => ({
		url: `${ Paths.handbooks.ownershipforms }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteOwnershipForms: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.ownershipforms }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetOwnershipFormsListQuery,
  useAddOwnershipFormsMutation,
  useEditOwnershipFormsMutation,
  useDeleteOwnershipFormsMutation
} = ownershipFormsApi;
